module.exports = __webpack_public_path__ + "img/26.a761d69b.jpg";